<template>
    <div class="order-wrapper">
        <!-- <v-container>
            <AppStageHeader
                :title="currentStage.title"
                :stageNumber="currentStage.index + 1"
                :stagesLength="stages.length"
            />
        </v-container> -->

        <div class="order-container">
            <v-form
                v-if="$vuetify.breakpoint.lgAndUp"
                v-model="stages[getStageIndex('car')].validForm"
                class="mb-2"
                style="width:100%"
                lazy-validation
                ref="carForm"
            >
                <v-select
                    v-model="cityId"
                    :items="cities"
                    item-text="name"
                    item-value="id"
                    label="Город"
                    :rules="[rules.required]"
                    @change="$router.push({ query: { cityId } })"
                />
            </v-form>
            <div v-else>
                <div v-if="cityId">
                    Город: {{ cities.find(city => city.id === cityId).name }}
                </div>
                <div>
                    <v-btn
                        class="block-change-mobile"
                        @click="showSelectCityDialog = true"
                        elevation="0"
                    >
                        <template v-if="!cityId">
                            <span style="margin-left:6px">Выбрать город</span>
                        </template>
                        <template v-else>
                            Изменить
                        </template>
                    </v-btn>
                </div>
            </div>
            <v-dialog
                v-model="showSelectCityDialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                scrollable
            >
                <div>
                    <v-card tile class="dialog-card">
                        <div>
                            <v-toolbar
                                flat
                            >
                                <v-toolbar-title>Город</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                    icon
                                    @click="showSelectCityDialog = false"
                                >
                                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32.251 30.2926C32.3439 30.3855 32.4176 30.4958 32.4679 30.6172C32.5182 30.7386 32.5441 30.8687 32.5441 31.0001C32.5441 31.1315 32.5182 31.2616 32.4679 31.383C32.4176 31.5044 32.3439 31.6147 32.251 31.7076C32.1581 31.8005 32.0478 31.8742 31.9264 31.9245C31.805 31.9747 31.6749 32.0006 31.5435 32.0006C31.4121 32.0006 31.282 31.9747 31.1606 31.9245C31.0392 31.8742 30.9289 31.8005 30.836 31.7076L22.5435 23.4138L14.251 31.7076C14.0634 31.8952 13.8089 32.0006 13.5435 32.0006C13.2782 32.0006 13.0237 31.8952 12.836 31.7076C12.6484 31.5199 12.543 31.2654 12.543 31.0001C12.543 30.7347 12.6484 30.4802 12.836 30.2926L21.1298 22.0001L12.836 13.7076C12.6484 13.5199 12.543 13.2654 12.543 13.0001C12.543 12.7347 12.6484 12.4802 12.836 12.2926C13.0237 12.1049 13.2782 11.9995 13.5435 11.9995C13.8089 11.9995 14.0634 12.1049 14.251 12.2926L22.5435 20.5863L30.836 12.2926C31.0237 12.1049 31.2782 11.9995 31.5435 11.9995C31.8089 11.9995 32.0634 12.1049 32.251 12.2926C32.4387 12.4802 32.5441 12.7347 32.5441 13.0001C32.5441 13.2654 32.4387 13.5199 32.251 13.7076L23.9573 22.0001L32.251 30.2926Z" fill="#DA251C"/>
                                    </svg>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-list>
                                    <v-list-item
                                        v-for="city in cities"
                                        :key="`city_${city.id}`"
                                        @click="setCityId(city.id)">
                                        <v-list-item-title>
                                            {{ city.name }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </div>
                    </v-card>
                </div>
            </v-dialog>
        </div>

        <a ref="car" />
        <div class="order-container" v-if="!cityId">
            <div class="step-header-wrapper">
                <div class="step-number">1</div>
                <div class="step-header">Ваши данные</div>
            </div>
        </div>
        <div class="order-container" v-if="cityId">
            <div class="step-header-wrapper mb-8">
                <div class="step-number" :class="{ 'passed': currentStage.index > 0, active: currentStage.index === 0 }">1</div>
                <div class="step-header">Ваши данные</div>
                <v-spacer v-if="currentStage.code !== 'car' && $vuetify.breakpoint.lgAndUp" />
                <div v-if="currentStage.code !== 'car' && $vuetify.breakpoint.lgAndUp">
                    <v-btn
                        class="block-change"
                        @click="dateTimeSelect = 'date';stageCode = 'car'"
                        elevation="0"
                    >
                        Изменить
                    </v-btn>
                </div>
            </div>
            <div v-if="currentStage.code === 'car'">
                <div class="step-subheader">Мои автомобили</div>
                <AppCarList :cars="cars" @selectCar="selectCar" :selectedCar="selectedCar && selectedCar.id || null" />
                <div class="step-action">
                    <v-btn
                        @click="nexStageFromCar"
                        :disabled="!carId"
                        elevation="0"
                    >
                        Перейти к видам работ
                    </v-btn>
                </div>
            </div>
            <div v-else class="selected-car-info">
                <CarItemInfo :car="selectedCar" />
            </div>
            <div v-if="currentStage.code !== 'car' && $vuetify.breakpoint.mdAndDown">
                <v-btn
                    class="block-change-mobile"
                    @click="dateTimeSelect = 'date';stageCode = 'car'"
                    elevation="0"
                >
                    Изменить
                </v-btn>
            </div>
        </div>

        <a ref="repair" />
        <div v-show="currentStage.index !==1" class="order-container">
            <div class="step-header-wrapper">
                <div class="step-number" :class="{ 'passed': currentStage.index > 1 }">2</div>
                <div class="step-header">Виды работ</div>
                <v-spacer v-if="currentStage.code !== 'repair' && $vuetify.breakpoint.lgAndUp" />
                <div v-if="currentStage.index > 1 && $vuetify.breakpoint.lgAndUp">
                    <v-btn
                        class="block-change"
                        @click="dateTimeSelect = 'date';stageCode = 'repair'"
                        elevation="0"
                    >
                        Изменить
                    </v-btn>
                </div>
            </div>
            <div v-if="currentStage.index > 1" class="selected-repairs">
                <div v-for="repairId in repairIds" :key="repairId" class="selected-repair">
                    {{getRepairName(repairId)}}
                </div>
            </div>
            <div v-if="currentStage.index > 1 && $vuetify.breakpoint.mdAndDown">
                <v-btn
                    class="block-change-mobile"
                    @click="dateTimeSelect = 'date';stageCode = 'repair'"
                    elevation="0"
                >
                    Изменить
                </v-btn>
            </div>
        </div>
        <div v-show="currentStage.index == 1" class="order-container">
            <div class="step-header-wrapper mb-8">
                <div class="step-number active">2</div>
                <div class="step-header">Виды работ</div>
            </div>
            <div class="repair-filters"></div>
            <div class="repairs" v-if="$vuetify.breakpoint.lgAndUp">
                <div class="repair-types-select">
                    <div v-for="type in repairTypes" :key="type.id" class="repair-type" :class="{'active': selectedRepairTypeId === type.id}" @click="() => { selectedRepairTypeId = type.id }">
                        <!-- добавить иконку типа -->
                        {{type.name}}
                    </div>
                </div>
                <v-list>
                    <v-list-item
                        v-for="repair in repairs"
                        :disabled="repair.disabled"
                        :key="`repair_${repair.id}`"
                        @click="toggleRepair(repair)">
                        <v-list-item-action>
                            <v-checkbox
                                v-model="repairIds"
                                :value="repair.id"
                                color="#DA251C"
                                class="repair-checkbox"
                                :class="{'active': repairIds.includes(repair.id)}"
                                hide-details
                                @click="toggleRepair(repair)"
                            />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ repair.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle style="text-wrap: wrap;font-size:0.8rem;">
                                {{ repair.description }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <div class="step-action">
                    <v-btn
                        @click="nextStage()"
                        :disabled="!repairIds.length"
                        elevation="0"
                    >
                        Перейти к выбору адреса
                    </v-btn>
                </div>
            </div>
            <div class="repairs-block-mobile" v-else>
                <div v-if="currentStage.index > 0" class="selected-repairs">
                    <template v-for="(repairId, index) in repairIds">
                        <div v-if="index < 3" :key="repairId" class="selected-repair">
                            <span v-if="index < 3">{{getRepairName(repairId)}}</span>
                        </div>
                    </template>
                    <div v-if="repairIds.length > 3" class="selected-repair">
                        {{`+ ${repairIds.length - 3} услуг${ending(repairIds.length - 3)}`}}
                    </div>
                </div>
                <div>
                    <v-btn
                        class="block-change-mobile"
                        @click="showSelectRepairDialog = true"
                        elevation="0"
                    >
                        <template v-if="!repairIds.length">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.375 5C7.375 4.83424 7.44085 4.67527 7.55806 4.55806C7.67527 4.44085 7.83424 4.375 8 4.375H17.375C17.5408 4.375 17.6997 4.44085 17.8169 4.55806C17.9342 4.67527 18 4.83424 18 5C18 5.16576 17.9342 5.32473 17.8169 5.44194C17.6997 5.55915 17.5408 5.625 17.375 5.625H8C7.83424 5.625 7.67527 5.55915 7.55806 5.44194C7.44085 5.32473 7.375 5.16576 7.375 5ZM17.375 9.375H8C7.83424 9.375 7.67527 9.44085 7.55806 9.55806C7.44085 9.67527 7.375 9.83424 7.375 10C7.375 10.1658 7.44085 10.3247 7.55806 10.4419C7.67527 10.5592 7.83424 10.625 8 10.625H17.375C17.5408 10.625 17.6997 10.5592 17.8169 10.4419C17.9342 10.3247 18 10.1658 18 10C18 9.83424 17.9342 9.67527 17.8169 9.55806C17.6997 9.44085 17.5408 9.375 17.375 9.375ZM17.375 14.375H8C7.83424 14.375 7.67527 14.4408 7.55806 14.5581C7.44085 14.6753 7.375 14.8342 7.375 15C7.375 15.1658 7.44085 15.3247 7.55806 15.4419C7.67527 15.5592 7.83424 15.625 8 15.625H17.375C17.5408 15.625 17.6997 15.5592 17.8169 15.4419C17.9342 15.3247 18 15.1658 18 15C18 14.8342 17.9342 14.6753 17.8169 14.5581C17.6997 14.4408 17.5408 14.375 17.375 14.375ZM4.875 4.375H3.625C3.45924 4.375 3.30027 4.44085 3.18306 4.55806C3.06585 4.67527 3 4.83424 3 5C3 5.16576 3.06585 5.32473 3.18306 5.44194C3.30027 5.55915 3.45924 5.625 3.625 5.625H4.875C5.04076 5.625 5.19973 5.55915 5.31694 5.44194C5.43415 5.32473 5.5 5.16576 5.5 5C5.5 4.83424 5.43415 4.67527 5.31694 4.55806C5.19973 4.44085 5.04076 4.375 4.875 4.375ZM4.875 9.375H3.625C3.45924 9.375 3.30027 9.44085 3.18306 9.55806C3.06585 9.67527 3 9.83424 3 10C3 10.1658 3.06585 10.3247 3.18306 10.4419C3.30027 10.5592 3.45924 10.625 3.625 10.625H4.875C5.04076 10.625 5.19973 10.5592 5.31694 10.4419C5.43415 10.3247 5.5 10.1658 5.5 10C5.5 9.83424 5.43415 9.67527 5.31694 9.55806C5.19973 9.44085 5.04076 9.375 4.875 9.375ZM4.875 14.375H3.625C3.45924 14.375 3.30027 14.4408 3.18306 14.5581C3.06585 14.6753 3 14.8342 3 15C3 15.1658 3.06585 15.3247 3.18306 15.4419C3.30027 15.5592 3.45924 15.625 3.625 15.625H4.875C5.04076 15.625 5.19973 15.5592 5.31694 15.4419C5.43415 15.3247 5.5 15.1658 5.5 15C5.5 14.8342 5.43415 14.6753 5.31694 14.5581C5.19973 14.4408 5.04076 14.375 4.875 14.375Z" fill="#DA251C"/>
                            </svg>
                            <span style="margin-left:6px">Перейти к выбору услуг</span>
                        </template>
                        <template v-else>
                            Список услуг
                        </template>
                    </v-btn>
                </div>
                <div class="step-action">
                    <v-btn
                        @click="nextStage()"
                        :disabled="!repairIds.length"
                        elevation="0"
                    >
                        Перейти к выбору адреса
                    </v-btn>
                </div>
            </div>
        </div>
        <a ref="address" />
        <div v-show="currentStage.index < 2" class="order-container">
            <div class="step-header-wrapper">
                <div class="step-number">3</div>
                <div class="step-header">Сервис и дата</div>
            </div>
        </div>
        <div v-show="currentStage.index > 2" class="order-container">
            <div class="step-header-wrapper">
                <div class="step-number" :class="{ 'passed': currentStage.index > 2 }">3</div>
                <div class="step-header">Сервис и дата</div>
                <v-spacer v-if="currentStage.code !== 'address' && $vuetify.breakpoint.lgAndUp" />
                <div v-if="currentStage.index > 2 && $vuetify.breakpoint.lgAndUp">
                    <v-btn
                        class="block-change"
                        @click="dateTimeSelect = 'date';stageCode = 'address'"
                        elevation="0"
                    >
                        Изменить
                    </v-btn>
                </div>
            </div>
            <div v-if="currentStage.index > 2" class="selected-repairs">
                <div v-if="$vuetify.breakpoint.lgAndUp" class="d-flex">
                    <div class="selected-station-card">
                        <div style="width: -webkit-fill-available; display:flex">
                            <div class="station-picture" style="margin:12px">
                                <v-img :src="selectedStation.photolink" contain />
                            </div>
                            <div class="selected-station-description">
                                <div>
                                    <div class="station-description-title">
                                        {{ selectedStation.name }}
                                    </div>
                                    <div class="station-description-text mt-2">
                                    </div>
                                    <div class="station-description-time">
                                        {{ selectedStation.worktime }}
                                    </div>
                                </div>
                                <v-btn
                                    elevation="0"
                                    class="station-get-route-btn block-change"
                                >
                                    <svg width="22.000000" height="22.000000" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <defs>
                                            <clipPath id="clip140_6751">
                                                <rect id="MapPinLine" width="22.000000" height="22.000000" fill="white" fill-opacity="0"/>
                                            </clipPath>
                                        </defs>
                                        <rect id="MapPinLine" width="22.000000" height="22.000000" fill="#FFFFFF" fill-opacity="0"/>
                                        <g clip-path="url(#clip140_6751)">
                                            <path id="Vector" d="M17.1875 19.25L12.9375 19.25C13.6514 18.6123 14.3242 17.9307 14.9531 17.209C17.3125 14.4961 18.5625 11.6357 18.5625 8.9375C18.5625 6.93164 17.7656 5.00781 16.3477 3.58984C14.9297 2.17188 13.0059 1.375 11 1.375C8.99414 1.375 7.07031 2.17188 5.65234 3.58984C4.23438 5.00781 3.4375 6.93164 3.4375 8.9375C3.4375 11.6357 4.68457 14.4961 7.04688 17.209C7.67578 17.9307 8.34863 18.6123 9.0625 19.25L4.8125 19.25C4.62988 19.25 4.45508 19.3223 4.32617 19.4512C4.19727 19.5801 4.125 19.7549 4.125 19.9375C4.125 20.1201 4.19727 20.2949 4.32617 20.4238C4.45508 20.5527 4.62988 20.625 4.8125 20.625L17.1875 20.625C17.3701 20.625 17.5449 20.5527 17.6738 20.4238C17.8027 20.2949 17.875 20.1201 17.875 19.9375C17.875 19.7549 17.8027 19.5801 17.6738 19.4512C17.5449 19.3223 17.3701 19.25 17.1875 19.25ZM11 6.1875C11.5439 6.1875 12.0752 6.34863 12.5273 6.65137C12.9805 6.95312 13.333 7.38281 13.541 7.88477C13.749 8.3877 13.8037 8.94043 13.6973 9.47363C13.5908 10.0078 13.3291 10.4971 12.9443 10.8818C12.5596 11.2666 12.0703 11.5283 11.5361 11.6348C11.0029 11.7412 10.4502 11.6865 9.94727 11.4785C9.44531 11.2705 9.01562 10.918 8.71387 10.4648C8.41113 10.0127 8.25 9.48145 8.25 8.9375C8.25 8.20801 8.54004 7.50879 9.05566 6.99316C9.57129 6.47754 10.2705 6.1875 11 6.1875Z" fill="#DA251C" fill-opacity="1.000000" fill-rule="nonzero"/>
                                        </g>
                                    </svg>
                                    <span class="btn-text">Построить маршрут</span>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="selected-station-card ml-5 pa-4">
                        <div class="station-description-title">
                            Дата и время визита
                        </div>
                        <div class="visit-date-time">
                            <svg width="24.000000" height="26.000000" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs/>
                                <path id="Vector" d="M22 2L19 2L19 1C19 0.734375 18.8945 0.480469 18.707 0.292969C18.5195 0.105469 18.2656 0 18 0C17.7344 0 17.4805 0.105469 17.293 0.292969C17.1055 0.480469 17 0.734375 17 1L17 2L7 2L7 1C7 0.734375 6.89453 0.480469 6.70703 0.292969C6.51953 0.105469 6.26562 0 6 0C5.73438 0 5.48047 0.105469 5.29297 0.292969C5.10547 0.480469 5 0.734375 5 1L5 2L2 2C1.46973 2 0.960938 2.21094 0.585938 2.58594C0.210938 2.96094 0 3.46973 0 4L0 24C0 24.5303 0.210938 25.0391 0.585938 25.4141C0.960938 25.7891 1.46973 26 2 26L22 26C22.5303 26 23.0391 25.7891 23.4141 25.4141C23.7891 25.0391 24 24.5303 24 24L24 4C24 3.46973 23.7891 2.96094 23.4141 2.58594C23.0391 2.21094 22.5303 2 22 2ZM5 4L5 5C5 5.26562 5.10547 5.51953 5.29297 5.70703C5.48047 5.89453 5.73438 6 6 6C6.26562 6 6.51953 5.89453 6.70703 5.70703C6.89453 5.51953 7 5.26562 7 5L7 4L17 4L17 5C17 5.26562 17.1055 5.51953 17.293 5.70703C17.4805 5.89453 17.7344 6 18 6C18.2656 6 18.5195 5.89453 18.707 5.70703C18.8945 5.51953 19 5.26562 19 5L19 4L22 4L22 8L2 8L2 4L5 4ZM22 24L2 24L2 10L22 10L22 24ZM10 13L10 21C10 21.2656 9.89453 21.5195 9.70703 21.707C9.51953 21.8945 9.26562 22 9 22C8.73438 22 8.48047 21.8945 8.29297 21.707C8.10547 21.5195 8 21.2656 8 21L8 14.6172L7.44727 14.8945C7.20996 15.0137 6.93555 15.0332 6.68359 14.9492C6.43164 14.8652 6.22363 14.6846 6.10547 14.4473C5.98633 14.21 5.9668 13.9355 6.05078 13.6836C6.13477 13.4316 6.31543 13.2236 6.55273 13.1055L8.55273 12.1055C8.70508 12.0283 8.875 11.9922 9.04492 12C9.21484 12.0078 9.38086 12.0586 9.52637 12.1484C9.6709 12.2383 9.79102 12.3633 9.87402 12.5127C9.95703 12.6621 10 12.8291 10 13ZM17.3945 16.8066L15 20L17 20C17.2656 20 17.5195 20.1055 17.707 20.293C17.8945 20.4805 18 20.7344 18 21C18 21.2656 17.8945 21.5195 17.707 21.707C17.5195 21.8945 17.2656 22 17 22L13 22C12.8145 22 12.6318 21.9482 12.4746 21.8506C12.3164 21.7529 12.1885 21.6133 12.1055 21.4473C12.0225 21.2812 11.9873 21.0947 12.0039 20.9102C12.0205 20.7256 12.0889 20.5488 12.2002 20.4004L15.7979 15.6035C15.8789 15.4951 15.9385 15.3701 15.9697 15.2383C16.002 15.1055 16.0068 14.9678 15.9834 14.834C15.96 14.6992 15.9102 14.5713 15.8359 14.457C15.7617 14.3428 15.6641 14.2451 15.5508 14.1699C15.4375 14.0947 15.3096 14.043 15.1758 14.0186C15.041 13.9951 14.9033 13.998 14.7715 14.0293C14.6387 14.0605 14.5137 14.1182 14.4033 14.1992C14.2939 14.2793 14.2021 14.3818 14.1338 14.5C14.0703 14.6172 13.9834 14.7207 13.8789 14.8037C13.7744 14.8877 13.6553 14.9492 13.5264 14.9854C13.3975 15.0215 13.2637 15.0312 13.1309 15.0146C12.998 14.998 12.8701 14.9551 12.7549 14.8887C12.6387 14.8223 12.5381 14.7324 12.457 14.626C12.377 14.5195 12.3184 14.3984 12.2861 14.2686C12.2529 14.1396 12.2461 14.0049 12.2666 13.8721C12.2861 13.7402 12.333 13.6143 12.4023 13.5C12.7324 12.9287 13.2422 12.4814 13.8525 12.2295C14.4629 11.9766 15.1387 11.9326 15.7764 12.1035C16.4141 12.2744 16.9775 12.6504 17.3799 13.1748C17.7822 13.6982 18 14.3398 18 15C18.002 15.6523 17.7891 16.2871 17.3945 16.8066Z" fill="#3fab3e" fill-opacity="1.000000" fill-rule="nonzero"/>
                            </svg>
                            {{ dateFormattedSplit.date }}
                        </div>
                        <div class="visit-date-time">
                            <svg width="24.000000" height="28.000000" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs/>
                                <path id="Vector" d="M12 4C9.62695 4 7.30664 4.7041 5.33301 6.02246C3.35938 7.34082 1.82129 9.21484 0.913086 11.4082C0.00488281 13.6006 -0.232422 16.0137 0.230469 18.3408C0.693359 20.6689 1.83691 22.8066 3.51465 24.4854C5.19336 26.1631 7.33105 27.3066 9.65918 27.7695C11.9863 28.2324 14.3994 27.9951 16.5918 27.0869C18.7852 26.1787 20.6592 24.6406 21.9775 22.667C23.2959 20.6934 24 18.373 24 16C23.9961 12.8184 22.7305 9.76855 20.4814 7.51855C18.2314 5.26953 15.1816 4.00391 12 4ZM12 26C10.0225 26 8.08887 25.4131 6.44434 24.3145C4.7998 23.2158 3.51855 21.6543 2.76074 19.8271C2.00391 18 1.80664 15.9893 2.19238 14.0488C2.57812 12.1094 3.53027 10.3271 4.92871 8.92871C6.32715 7.53027 8.10938 6.57812 10.0488 6.19238C11.9893 5.80664 14 6.00391 15.8271 6.76074C17.6543 7.51855 19.2158 8.7998 20.3145 10.4443C21.4131 12.0889 22 14.0225 22 16C21.9971 18.6514 20.9424 21.1934 19.0674 23.0674C17.1934 24.9424 14.6514 25.9971 12 26ZM17.707 10.293C17.8008 10.3857 17.874 10.4961 17.9248 10.6172C17.9746 10.7383 18.001 10.8682 18.001 11C18.001 11.1318 17.9746 11.2617 17.9248 11.3828C17.874 11.5039 17.8008 11.6143 17.707 11.707L12.707 16.707C12.6143 16.8008 12.5039 16.874 12.3828 16.9248C12.2617 16.9746 12.1318 17.001 12 17.001C11.8682 17.001 11.7383 16.9746 11.6172 16.9248C11.4961 16.874 11.3857 16.8008 11.293 16.707C11.1992 16.6143 11.126 16.5039 11.0752 16.3828C11.0254 16.2617 10.999 16.1318 10.999 16C10.999 15.8682 11.0254 15.7383 11.0752 15.6172C11.126 15.4961 11.1992 15.3857 11.293 15.293L16.293 10.293C16.3857 10.1992 16.4961 10.126 16.6172 10.0752C16.7383 10.0254 16.8682 9.99902 17 9.99902C17.1318 9.99902 17.2617 10.0254 17.3828 10.0752C17.5039 10.126 17.6143 10.1992 17.707 10.293ZM8 1C8 0.734375 8.10547 0.480469 8.29297 0.292969C8.48047 0.105469 8.73438 0 9 0L15 0C15.2656 0 15.5195 0.105469 15.707 0.292969C15.8945 0.480469 16 0.734375 16 1C16 1.26562 15.8945 1.51953 15.707 1.70703C15.5195 1.89453 15.2656 2 15 2L9 2C8.73438 2 8.48047 1.89453 8.29297 1.70703C8.10547 1.51953 8 1.26562 8 1Z" fill="#3fab3e" fill-opacity="1.000000" fill-rule="nonzero"/>
                            </svg>

                            {{ dateFormattedSplit.time }}
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="selected-station-card">
                        <div style="width: -webkit-fill-available; display:flex;flex-direction: column;">
                            <div class="station-picture" style="margin:12px">
                                <v-img :src="selectedStation.photolink" contain />
                            </div>
                            <div class="selected-station-description">
                                <div class="mb-4">
                                    <div class="station-description-title">
                                        {{ selectedStation.name }}
                                    </div>
                                    <div class="station-description-text mt-2">
                                    </div>
                                    <div class="station-description-time">
                                        {{ selectedStation.worktime }}
                                    </div>
                                </div>
                                <v-btn
                                    elevation="0"
                                    class="station-get-route-btn block-change"
                                >
                                    <svg width="22.000000" height="22.000000" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <defs>
                                            <clipPath id="clip140_6751">
                                                <rect id="MapPinLine" width="22.000000" height="22.000000" fill="white" fill-opacity="0"/>
                                            </clipPath>
                                        </defs>
                                        <rect id="MapPinLine" width="22.000000" height="22.000000" fill="#FFFFFF" fill-opacity="0"/>
                                        <g clip-path="url(#clip140_6751)">
                                            <path id="Vector" d="M17.1875 19.25L12.9375 19.25C13.6514 18.6123 14.3242 17.9307 14.9531 17.209C17.3125 14.4961 18.5625 11.6357 18.5625 8.9375C18.5625 6.93164 17.7656 5.00781 16.3477 3.58984C14.9297 2.17188 13.0059 1.375 11 1.375C8.99414 1.375 7.07031 2.17188 5.65234 3.58984C4.23438 5.00781 3.4375 6.93164 3.4375 8.9375C3.4375 11.6357 4.68457 14.4961 7.04688 17.209C7.67578 17.9307 8.34863 18.6123 9.0625 19.25L4.8125 19.25C4.62988 19.25 4.45508 19.3223 4.32617 19.4512C4.19727 19.5801 4.125 19.7549 4.125 19.9375C4.125 20.1201 4.19727 20.2949 4.32617 20.4238C4.45508 20.5527 4.62988 20.625 4.8125 20.625L17.1875 20.625C17.3701 20.625 17.5449 20.5527 17.6738 20.4238C17.8027 20.2949 17.875 20.1201 17.875 19.9375C17.875 19.7549 17.8027 19.5801 17.6738 19.4512C17.5449 19.3223 17.3701 19.25 17.1875 19.25ZM11 6.1875C11.5439 6.1875 12.0752 6.34863 12.5273 6.65137C12.9805 6.95312 13.333 7.38281 13.541 7.88477C13.749 8.3877 13.8037 8.94043 13.6973 9.47363C13.5908 10.0078 13.3291 10.4971 12.9443 10.8818C12.5596 11.2666 12.0703 11.5283 11.5361 11.6348C11.0029 11.7412 10.4502 11.6865 9.94727 11.4785C9.44531 11.2705 9.01562 10.918 8.71387 10.4648C8.41113 10.0127 8.25 9.48145 8.25 8.9375C8.25 8.20801 8.54004 7.50879 9.05566 6.99316C9.57129 6.47754 10.2705 6.1875 11 6.1875Z" fill="#DA251C" fill-opacity="1.000000" fill-rule="nonzero"/>
                                        </g>
                                    </svg>
                                    <span class="btn-text">Построить маршрут</span>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="selected-station-card-mobile">
                        <div class="station-description-title">
                            Дата и время
                        </div>
                        <div class="selected-station-card pa-4">
                            <div class="visit-date-time">
                                <svg width="24.000000" height="26.000000" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <defs/>
                                    <path id="Vector" d="M22 2L19 2L19 1C19 0.734375 18.8945 0.480469 18.707 0.292969C18.5195 0.105469 18.2656 0 18 0C17.7344 0 17.4805 0.105469 17.293 0.292969C17.1055 0.480469 17 0.734375 17 1L17 2L7 2L7 1C7 0.734375 6.89453 0.480469 6.70703 0.292969C6.51953 0.105469 6.26562 0 6 0C5.73438 0 5.48047 0.105469 5.29297 0.292969C5.10547 0.480469 5 0.734375 5 1L5 2L2 2C1.46973 2 0.960938 2.21094 0.585938 2.58594C0.210938 2.96094 0 3.46973 0 4L0 24C0 24.5303 0.210938 25.0391 0.585938 25.4141C0.960938 25.7891 1.46973 26 2 26L22 26C22.5303 26 23.0391 25.7891 23.4141 25.4141C23.7891 25.0391 24 24.5303 24 24L24 4C24 3.46973 23.7891 2.96094 23.4141 2.58594C23.0391 2.21094 22.5303 2 22 2ZM5 4L5 5C5 5.26562 5.10547 5.51953 5.29297 5.70703C5.48047 5.89453 5.73438 6 6 6C6.26562 6 6.51953 5.89453 6.70703 5.70703C6.89453 5.51953 7 5.26562 7 5L7 4L17 4L17 5C17 5.26562 17.1055 5.51953 17.293 5.70703C17.4805 5.89453 17.7344 6 18 6C18.2656 6 18.5195 5.89453 18.707 5.70703C18.8945 5.51953 19 5.26562 19 5L19 4L22 4L22 8L2 8L2 4L5 4ZM22 24L2 24L2 10L22 10L22 24ZM10 13L10 21C10 21.2656 9.89453 21.5195 9.70703 21.707C9.51953 21.8945 9.26562 22 9 22C8.73438 22 8.48047 21.8945 8.29297 21.707C8.10547 21.5195 8 21.2656 8 21L8 14.6172L7.44727 14.8945C7.20996 15.0137 6.93555 15.0332 6.68359 14.9492C6.43164 14.8652 6.22363 14.6846 6.10547 14.4473C5.98633 14.21 5.9668 13.9355 6.05078 13.6836C6.13477 13.4316 6.31543 13.2236 6.55273 13.1055L8.55273 12.1055C8.70508 12.0283 8.875 11.9922 9.04492 12C9.21484 12.0078 9.38086 12.0586 9.52637 12.1484C9.6709 12.2383 9.79102 12.3633 9.87402 12.5127C9.95703 12.6621 10 12.8291 10 13ZM17.3945 16.8066L15 20L17 20C17.2656 20 17.5195 20.1055 17.707 20.293C17.8945 20.4805 18 20.7344 18 21C18 21.2656 17.8945 21.5195 17.707 21.707C17.5195 21.8945 17.2656 22 17 22L13 22C12.8145 22 12.6318 21.9482 12.4746 21.8506C12.3164 21.7529 12.1885 21.6133 12.1055 21.4473C12.0225 21.2812 11.9873 21.0947 12.0039 20.9102C12.0205 20.7256 12.0889 20.5488 12.2002 20.4004L15.7979 15.6035C15.8789 15.4951 15.9385 15.3701 15.9697 15.2383C16.002 15.1055 16.0068 14.9678 15.9834 14.834C15.96 14.6992 15.9102 14.5713 15.8359 14.457C15.7617 14.3428 15.6641 14.2451 15.5508 14.1699C15.4375 14.0947 15.3096 14.043 15.1758 14.0186C15.041 13.9951 14.9033 13.998 14.7715 14.0293C14.6387 14.0605 14.5137 14.1182 14.4033 14.1992C14.2939 14.2793 14.2021 14.3818 14.1338 14.5C14.0703 14.6172 13.9834 14.7207 13.8789 14.8037C13.7744 14.8877 13.6553 14.9492 13.5264 14.9854C13.3975 15.0215 13.2637 15.0312 13.1309 15.0146C12.998 14.998 12.8701 14.9551 12.7549 14.8887C12.6387 14.8223 12.5381 14.7324 12.457 14.626C12.377 14.5195 12.3184 14.3984 12.2861 14.2686C12.2529 14.1396 12.2461 14.0049 12.2666 13.8721C12.2861 13.7402 12.333 13.6143 12.4023 13.5C12.7324 12.9287 13.2422 12.4814 13.8525 12.2295C14.4629 11.9766 15.1387 11.9326 15.7764 12.1035C16.4141 12.2744 16.9775 12.6504 17.3799 13.1748C17.7822 13.6982 18 14.3398 18 15C18.002 15.6523 17.7891 16.2871 17.3945 16.8066Z" fill="#3fab3e" fill-opacity="1.000000" fill-rule="nonzero"/>
                                </svg>
                                {{ dateFormattedSplit.date }}
                            </div>
                            <div class="visit-date-time">
                                <svg width="24.000000" height="28.000000" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <defs/>
                                    <path id="Vector" d="M12 4C9.62695 4 7.30664 4.7041 5.33301 6.02246C3.35938 7.34082 1.82129 9.21484 0.913086 11.4082C0.00488281 13.6006 -0.232422 16.0137 0.230469 18.3408C0.693359 20.6689 1.83691 22.8066 3.51465 24.4854C5.19336 26.1631 7.33105 27.3066 9.65918 27.7695C11.9863 28.2324 14.3994 27.9951 16.5918 27.0869C18.7852 26.1787 20.6592 24.6406 21.9775 22.667C23.2959 20.6934 24 18.373 24 16C23.9961 12.8184 22.7305 9.76855 20.4814 7.51855C18.2314 5.26953 15.1816 4.00391 12 4ZM12 26C10.0225 26 8.08887 25.4131 6.44434 24.3145C4.7998 23.2158 3.51855 21.6543 2.76074 19.8271C2.00391 18 1.80664 15.9893 2.19238 14.0488C2.57812 12.1094 3.53027 10.3271 4.92871 8.92871C6.32715 7.53027 8.10938 6.57812 10.0488 6.19238C11.9893 5.80664 14 6.00391 15.8271 6.76074C17.6543 7.51855 19.2158 8.7998 20.3145 10.4443C21.4131 12.0889 22 14.0225 22 16C21.9971 18.6514 20.9424 21.1934 19.0674 23.0674C17.1934 24.9424 14.6514 25.9971 12 26ZM17.707 10.293C17.8008 10.3857 17.874 10.4961 17.9248 10.6172C17.9746 10.7383 18.001 10.8682 18.001 11C18.001 11.1318 17.9746 11.2617 17.9248 11.3828C17.874 11.5039 17.8008 11.6143 17.707 11.707L12.707 16.707C12.6143 16.8008 12.5039 16.874 12.3828 16.9248C12.2617 16.9746 12.1318 17.001 12 17.001C11.8682 17.001 11.7383 16.9746 11.6172 16.9248C11.4961 16.874 11.3857 16.8008 11.293 16.707C11.1992 16.6143 11.126 16.5039 11.0752 16.3828C11.0254 16.2617 10.999 16.1318 10.999 16C10.999 15.8682 11.0254 15.7383 11.0752 15.6172C11.126 15.4961 11.1992 15.3857 11.293 15.293L16.293 10.293C16.3857 10.1992 16.4961 10.126 16.6172 10.0752C16.7383 10.0254 16.8682 9.99902 17 9.99902C17.1318 9.99902 17.2617 10.0254 17.3828 10.0752C17.5039 10.126 17.6143 10.1992 17.707 10.293ZM8 1C8 0.734375 8.10547 0.480469 8.29297 0.292969C8.48047 0.105469 8.73438 0 9 0L15 0C15.2656 0 15.5195 0.105469 15.707 0.292969C15.8945 0.480469 16 0.734375 16 1C16 1.26562 15.8945 1.51953 15.707 1.70703C15.5195 1.89453 15.2656 2 15 2L9 2C8.73438 2 8.48047 1.89453 8.29297 1.70703C8.10547 1.51953 8 1.26562 8 1Z" fill="#3fab3e" fill-opacity="1.000000" fill-rule="nonzero"/>
                                </svg>

                                {{ dateFormattedSplit.time }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="currentStage.index > 2 && $vuetify.breakpoint.mdAndDown">
                <v-btn
                    class="block-change-mobile"
                    @click="dateTimeSelect = 'date';stageCode = 'address'"
                    elevation="0"
                >
                    Изменить
                </v-btn>
            </div>
        </div>
        <div v-show="currentStage.index === 2" class="order-container">
            <div class="step-header-wrapper mb-8">
                <div class="step-number" :class="{ 'passed': currentStage.index > 2, active: currentStage.index === 2 }">3</div>
                <div class="step-header">Сервис и дата</div>
            </div>
            <div class="step-subheader">Филиалы центра в вашем городе</div>

            <div class="stations-list" v-if="$vuetify.breakpoint.lgAndUp">
                <div
                    v-for="station in stations"
                    :key="`station_${station.id}`"
                >
                    <AppStationItem
                        :color="station.id === stationId ? 'grey lighten-2' : ''"
                        :station="station"
                        :distance="getDistance(station)"
                        @select="selectStation(station.id)"
                        :selected="stationId === station.id"
                    />
                </div>
            </div>
            <div v-else>
                <v-carousel
                    class="stations-carousel"
                    :show-arrows="false"
                    style="height:420px"
                >
                    <v-carousel-item
                        v-for="station in stations"
                        :key="`station_${station.id}`"
                    >
                        <AppStationItem
                            :color="station.id === stationId ? 'grey lighten-2' : ''"
                            :station="station"
                            :distance="getDistance(station)"
                            @select="selectStation(station.id)"
                            :selected="stationId === station.id"
                        />
                    </v-carousel-item>
                </v-carousel>
            </div>

            <a ref="date" />
            <div class="date">
                <div class="step-subheader">Визит</div>
                <div v-if="$vuetify.breakpoint.lgAndUp">
                    <div>Дата и время визита</div>
                    <div class="date-picker">
                        <v-menu
                            v-model="isShownDatePicker"
                            :close-on-content-click="false"
                            :nudge-right="0"
                            offset-y
                            width="348px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    readonly
                                    :value="dateFormatted"
                                    :disabled="!stationId"
                                    v-on="on"
                                    outlined
                                    hide-details
                                    placeholder="Выберите дату и время визита"
                                >
                                    <template v-slot:append>
                                        <v-btn icon v-on="on" style="margin-top:0; heught:44px" :disabled="!stationId">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.5 3H17.25V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25V3H8.25V2.25C8.25 2.05109 8.17098 1.86032 8.03033 1.71967C7.88968 1.57902 7.69891 1.5 7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM6.75 4.5V5.25C6.75 5.44891 6.82902 5.63968 6.96967 5.78033C7.11032 5.92098 7.30109 6 7.5 6C7.69891 6 7.88968 5.92098 8.03033 5.78033C8.17098 5.63968 8.25 5.44891 8.25 5.25V4.5H15.75V5.25C15.75 5.44891 15.829 5.63968 15.9697 5.78033C16.1103 5.92098 16.3011 6 16.5 6C16.6989 6 16.8897 5.92098 17.0303 5.78033C17.171 5.63968 17.25 5.44891 17.25 5.25V4.5H19.5V7.5H4.5V4.5H6.75ZM19.5 19.5H4.5V9H19.5V19.5ZM10.5 11.25V17.25C10.5 17.4489 10.421 17.6397 10.2803 17.7803C10.1397 17.921 9.94891 18 9.75 18C9.55109 18 9.36032 17.921 9.21967 17.7803C9.07902 17.6397 9 17.4489 9 17.25V12.4631L8.58563 12.6713C8.4076 12.7603 8.2015 12.7749 8.01268 12.712C7.82385 12.649 7.66776 12.5137 7.57875 12.3356C7.48974 12.1576 7.47509 11.9515 7.53803 11.7627C7.60097 11.5739 7.73635 11.4178 7.91437 11.3287L9.41437 10.5787C9.52876 10.5215 9.65589 10.4945 9.78367 10.5002C9.91145 10.506 10.0356 10.5443 10.1444 10.6116C10.2532 10.6788 10.343 10.7728 10.4052 10.8845C10.4675 10.9963 10.5001 11.1221 10.5 11.25ZM16.0463 14.1047L14.25 16.5H15.75C15.9489 16.5 16.1397 16.579 16.2803 16.7197C16.421 16.8603 16.5 17.0511 16.5 17.25C16.5 17.4489 16.421 17.6397 16.2803 17.7803C16.1397 17.921 15.9489 18 15.75 18H12.75C12.6107 18 12.4742 17.9612 12.3557 17.888C12.2372 17.8148 12.1415 17.71 12.0792 17.5854C12.0169 17.4608 11.9905 17.3214 12.003 17.1826C12.0155 17.0439 12.0664 16.9114 12.15 16.8L14.8481 13.2028C14.9095 13.1211 14.9535 13.0277 14.9775 12.9284C15.0015 12.8291 15.0049 12.7259 14.9876 12.6252C14.9703 12.5245 14.9325 12.4284 14.8767 12.3428C14.8209 12.2572 14.7482 12.1839 14.6631 12.1274C14.5779 12.0709 14.4821 12.0324 14.3816 12.0143C14.281 11.9961 14.1778 11.9987 14.0783 12.0219C13.9788 12.0451 13.885 12.0884 13.8028 12.1491C13.7206 12.2098 13.6517 12.2867 13.6003 12.375C13.5525 12.463 13.4876 12.5406 13.4093 12.6031C13.3311 12.6656 13.2411 12.7118 13.1447 12.739C13.0483 12.7661 12.9474 12.7737 12.8481 12.7613C12.7487 12.7489 12.6528 12.7166 12.5661 12.6665C12.4794 12.6165 12.4035 12.5495 12.3431 12.4696C12.2827 12.3898 12.2389 12.2986 12.2142 12.2015C12.1896 12.1044 12.1847 12.0034 12.1997 11.9044C12.2148 11.8054 12.2495 11.7104 12.3019 11.625C12.5496 11.1963 12.9319 10.8612 13.3894 10.6718C13.8469 10.4824 14.3541 10.4493 14.8324 10.5774C15.3107 10.7056 15.7333 10.988 16.0348 11.3808C16.3363 11.7736 16.4998 12.2548 16.5 12.75C16.5016 13.2391 16.3421 13.7152 16.0463 14.1047Z" fill="#DA251C"/>
                                            </svg>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </template>
                            <div v-if="dateTimeSelect==='time'" class="time-select d-flex align-center" style="width:348px; z-index:999;background:white;min-height:200px">
                                <v-row justify="center" no-gutters style="width:348px; z-index:999;background:white;" v-show="fetchingTime">
                                    <v-col style="text-align:center;">
                                        <v-progress-circular
                                            indeterminate
                                            color="red"
                                        ></v-progress-circular>
                                    </v-col>
                                </v-row>
                                <div v-show="!fetchingTime" class="align-self-start">
                                    <div class="d-flex align-center justify-space-between">
                                        <v-btn icon @click="dateTimeSelect='date'">
                                            <v-icon small icon="'$chevronLeft'" />
                                        </v-btn>
                                        <div class="mr-12">
                                            Выберите свободное время
                                        </div>
                                    </div>
                                    <v-row justify="space-between" no-gutters style="width:348px; z-index:999;background:white;">
                                        <v-col
                                            v-for="(timeItem, timeItemIndex) in times"
                                            :key="`time_${timeItemIndex}`"
                                            class="pa-1"
                                            cols="auto">
                                            <v-chip
                                                :color="timeItem.isBusy ? 'grey lighten-2' : (timeItem.isActive ? 'primary' : 'transparent')"
                                                :disabled="timeItem.isBusy"
                                                :input-value="timeItem.isActive"
                                                @click="selectTime(timeItemIndex); isShownDatePicker=false">
                                                {{ timeItem.time }}
                                            </v-chip>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                            <v-date-picker
                                v-else
                                v-model="date"
                                :first-day-of-week="1"
                                width="348px"
                                no-title
                                @input="dateTimeSelect = 'time'; fetchFreeTime()"
                                next-icon="$chevronRight"
                                prev-icon="$chevronLeft"
                                :header-date-format="monthFormat"
                            />
                        </v-menu>
                    </div>
                </div>
                <div v-else>
                    <v-btn
                        class="block-change-mobile"
                        @click="showSelectDateTime = true"
                        elevation="0"
                        :disabled="!stationId"
                    >
                        <svg width="15.000000" height="16.250000" viewBox="0 0 15 16.25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs/>
                            <path id="Vector" d="M13.75 1.25L11.875 1.25L11.875 0.625C11.875 0.459229 11.8086 0.300293 11.6914 0.183105C11.5742 0.065918 11.416 0 11.25 0C11.084 0 10.9258 0.065918 10.8086 0.183105C10.6914 0.300293 10.625 0.459229 10.625 0.625L10.625 1.25L4.375 1.25L4.375 0.625C4.375 0.459229 4.30859 0.300293 4.19141 0.183105C4.07422 0.065918 3.91602 0 3.75 0C3.58398 0 3.42578 0.065918 3.30859 0.183105C3.19141 0.300293 3.125 0.459229 3.125 0.625L3.125 1.25L1.25 1.25C0.917969 1.25 0.599609 1.38159 0.365234 1.61621C0.130859 1.85059 0 2.16846 0 2.5L0 15C0 15.3315 0.130859 15.6494 0.365234 15.8838C0.599609 16.1184 0.917969 16.25 1.25 16.25L13.75 16.25C14.082 16.25 14.4004 16.1184 14.6348 15.8838C14.8691 15.6494 15 15.3315 15 15L15 2.5C15 2.16846 14.8691 1.85059 14.6348 1.61621C14.4004 1.38159 14.082 1.25 13.75 1.25ZM3.125 2.5L3.125 3.125C3.125 3.29077 3.19141 3.44971 3.30859 3.56689C3.42578 3.68408 3.58398 3.75 3.75 3.75C3.91602 3.75 4.07422 3.68408 4.19141 3.56689C4.30859 3.44971 4.375 3.29077 4.375 3.125L4.375 2.5L10.625 2.5L10.625 3.125C10.625 3.29077 10.6914 3.44971 10.8086 3.56689C10.9258 3.68408 11.084 3.75 11.25 3.75C11.416 3.75 11.5742 3.68408 11.6914 3.56689C11.8086 3.44971 11.875 3.29077 11.875 3.125L11.875 2.5L13.75 2.5L13.75 5L1.25 5L1.25 2.5L3.125 2.5ZM13.75 15L1.25 15L1.25 6.25L13.75 6.25L13.75 15ZM6.25 8.125L6.25 13.125C6.25 13.2908 6.18359 13.4497 6.06641 13.5669C5.94922 13.6841 5.79102 13.75 5.625 13.75C5.45898 13.75 5.30078 13.6841 5.18359 13.5669C5.06641 13.4497 5 13.2908 5 13.125L5 9.13599L4.6543 9.30933C4.50586 9.38354 4.33398 9.39575 4.17773 9.34326C4.01953 9.29077 3.89062 9.17798 3.81641 9.02979C3.74219 8.88135 3.72852 8.70947 3.78125 8.55225C3.83398 8.39478 3.94727 8.26489 4.0957 8.19067L5.3457 7.56567C5.44141 7.51782 5.54688 7.49536 5.65234 7.50024C5.75977 7.50488 5.86328 7.53687 5.95312 7.59302C6.04492 7.64893 6.11914 7.72729 6.17188 7.82056C6.22266 7.91357 6.25 8.01831 6.25 8.125ZM10.8711 10.5039L9.375 12.5L10.625 12.5C10.791 12.5 10.9492 12.5659 11.0664 12.6831C11.1836 12.8003 11.25 12.9592 11.25 13.125C11.25 13.2908 11.1836 13.4497 11.0664 13.5669C10.9492 13.6841 10.791 13.75 10.625 13.75L8.125 13.75C8.00977 13.75 7.89453 13.7178 7.79688 13.6567C7.69727 13.5957 7.61719 13.5083 7.56641 13.4045C7.51367 13.3008 7.49219 13.1846 7.50195 13.0688C7.51367 12.9534 7.55469 12.8428 7.625 12.75L9.87305 9.75244C9.92383 9.68433 9.96094 9.60645 9.98047 9.52368C10.002 9.44092 10.0039 9.35498 9.99023 9.271C9.97461 9.18701 9.94336 9.10693 9.89648 9.03564C9.85156 8.96436 9.79102 8.90332 9.71875 8.8562C9.64844 8.80908 9.56836 8.7771 9.48438 8.76196C9.40039 8.74683 9.31445 8.74902 9.23242 8.76831C9.14844 8.7876 9.07031 8.82373 9.00195 8.87427C8.93359 8.9248 8.87695 8.98901 8.83398 9.0625C8.79297 9.13574 8.74023 9.20044 8.67383 9.25244C8.60938 9.30469 8.53516 9.34326 8.45312 9.36572C8.37305 9.38843 8.28906 9.39478 8.20703 9.38452C8.12305 9.37402 8.04492 9.34717 7.97266 9.30542C7.90039 9.26367 7.83594 9.20801 7.78516 9.14136C7.73633 9.07471 7.69922 8.99878 7.67773 8.91797C7.6582 8.83691 7.6543 8.75293 7.66602 8.67041C7.67969 8.58789 7.70703 8.50854 7.75195 8.4375C7.95898 8.08032 8.27734 7.80103 8.6582 7.64331C9.03906 7.48535 9.46094 7.45776 9.85938 7.56445C10.2598 7.67139 10.6113 7.90674 10.8633 8.23389C11.1133 8.56128 11.25 8.9624 11.25 9.375C11.252 9.78271 11.1191 10.1794 10.8711 10.5039Z" fill="#DA251C" fill-opacity="1.000000" fill-rule="nonzero"/>
                        </svg>
                        <span class="ml-2" v-if="$vuetify.breakpoint.lgAndUp">Выбрать дату и время</span>
                        <span class="ml-2" v-else>
                            <span v-if="!time">Выбрать дату и время</span>
                            <span v-else>{{ dateFormattedMobile }}</span>
                        </span>
                    </v-btn>
                </div>
            </div>

            <div class="step-action">
                <v-btn
                    @click="nextStage()"
                    :disabled="!time"
                    elevation="0"
                >
                    Перейти к подтверждению
                </v-btn>
            </div>
        </div>

        <a ref="end" />
        <div class="order-container" v-if="stageCode !== 'end'">
            <div class="step-header-wrapper">
                <div class="step-number">4</div>
                <div class="step-header">Подтверждение</div>
            </div>
        </div>
        <div v-if="stageCode === 'end'" class="order-container">
            <div class="step-header-wrapper mb-8">
                <div class="step-number" :class="{ 'passed': currentStage.index > 4, active: currentStage.index === 4 }">4</div>
                <div class="step-header">Подтверждение</div>
            </div>
            <div class="step-subheader">Заказ наряд № ЕПЦБ-000256</div>
            <span>
                Проверьте заявку и подтвердите запись. Вышлем уведомление о записи в смс и напомним за день до визита.
            </span>
            <div class="selected-data d-flex mt-8" style="gap:20px">
                <div class="selected-auto">
                    <div class="block-header">
                        Ваш автомобиль
                    </div>
                    <div class="selected-data-card pa-4">
                        <CarItemInfo :car="selectedCar" />
                    </div>
                </div>
                <div class="selected-auto">
                    <div class="block-header">
                        Дата и время
                    </div>
                    <div class="selected-data-card pa-4">
                        <div>
                            <div class="visit-date-time">
                                <svg width="24.000000" height="26.000000" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <defs/>
                                    <path id="Vector" d="M22 2L19 2L19 1C19 0.734375 18.8945 0.480469 18.707 0.292969C18.5195 0.105469 18.2656 0 18 0C17.7344 0 17.4805 0.105469 17.293 0.292969C17.1055 0.480469 17 0.734375 17 1L17 2L7 2L7 1C7 0.734375 6.89453 0.480469 6.70703 0.292969C6.51953 0.105469 6.26562 0 6 0C5.73438 0 5.48047 0.105469 5.29297 0.292969C5.10547 0.480469 5 0.734375 5 1L5 2L2 2C1.46973 2 0.960938 2.21094 0.585938 2.58594C0.210938 2.96094 0 3.46973 0 4L0 24C0 24.5303 0.210938 25.0391 0.585938 25.4141C0.960938 25.7891 1.46973 26 2 26L22 26C22.5303 26 23.0391 25.7891 23.4141 25.4141C23.7891 25.0391 24 24.5303 24 24L24 4C24 3.46973 23.7891 2.96094 23.4141 2.58594C23.0391 2.21094 22.5303 2 22 2ZM5 4L5 5C5 5.26562 5.10547 5.51953 5.29297 5.70703C5.48047 5.89453 5.73438 6 6 6C6.26562 6 6.51953 5.89453 6.70703 5.70703C6.89453 5.51953 7 5.26562 7 5L7 4L17 4L17 5C17 5.26562 17.1055 5.51953 17.293 5.70703C17.4805 5.89453 17.7344 6 18 6C18.2656 6 18.5195 5.89453 18.707 5.70703C18.8945 5.51953 19 5.26562 19 5L19 4L22 4L22 8L2 8L2 4L5 4ZM22 24L2 24L2 10L22 10L22 24ZM10 13L10 21C10 21.2656 9.89453 21.5195 9.70703 21.707C9.51953 21.8945 9.26562 22 9 22C8.73438 22 8.48047 21.8945 8.29297 21.707C8.10547 21.5195 8 21.2656 8 21L8 14.6172L7.44727 14.8945C7.20996 15.0137 6.93555 15.0332 6.68359 14.9492C6.43164 14.8652 6.22363 14.6846 6.10547 14.4473C5.98633 14.21 5.9668 13.9355 6.05078 13.6836C6.13477 13.4316 6.31543 13.2236 6.55273 13.1055L8.55273 12.1055C8.70508 12.0283 8.875 11.9922 9.04492 12C9.21484 12.0078 9.38086 12.0586 9.52637 12.1484C9.6709 12.2383 9.79102 12.3633 9.87402 12.5127C9.95703 12.6621 10 12.8291 10 13ZM17.3945 16.8066L15 20L17 20C17.2656 20 17.5195 20.1055 17.707 20.293C17.8945 20.4805 18 20.7344 18 21C18 21.2656 17.8945 21.5195 17.707 21.707C17.5195 21.8945 17.2656 22 17 22L13 22C12.8145 22 12.6318 21.9482 12.4746 21.8506C12.3164 21.7529 12.1885 21.6133 12.1055 21.4473C12.0225 21.2812 11.9873 21.0947 12.0039 20.9102C12.0205 20.7256 12.0889 20.5488 12.2002 20.4004L15.7979 15.6035C15.8789 15.4951 15.9385 15.3701 15.9697 15.2383C16.002 15.1055 16.0068 14.9678 15.9834 14.834C15.96 14.6992 15.9102 14.5713 15.8359 14.457C15.7617 14.3428 15.6641 14.2451 15.5508 14.1699C15.4375 14.0947 15.3096 14.043 15.1758 14.0186C15.041 13.9951 14.9033 13.998 14.7715 14.0293C14.6387 14.0605 14.5137 14.1182 14.4033 14.1992C14.2939 14.2793 14.2021 14.3818 14.1338 14.5C14.0703 14.6172 13.9834 14.7207 13.8789 14.8037C13.7744 14.8877 13.6553 14.9492 13.5264 14.9854C13.3975 15.0215 13.2637 15.0312 13.1309 15.0146C12.998 14.998 12.8701 14.9551 12.7549 14.8887C12.6387 14.8223 12.5381 14.7324 12.457 14.626C12.377 14.5195 12.3184 14.3984 12.2861 14.2686C12.2529 14.1396 12.2461 14.0049 12.2666 13.8721C12.2861 13.7402 12.333 13.6143 12.4023 13.5C12.7324 12.9287 13.2422 12.4814 13.8525 12.2295C14.4629 11.9766 15.1387 11.9326 15.7764 12.1035C16.4141 12.2744 16.9775 12.6504 17.3799 13.1748C17.7822 13.6982 18 14.3398 18 15C18.002 15.6523 17.7891 16.2871 17.3945 16.8066Z" fill="#3fab3e" fill-opacity="1.000000" fill-rule="nonzero"/>
                                </svg>
                                {{ dateFormattedSplit.date }}
                            </div>
                            <div class="visit-date-time">
                                <svg width="24.000000" height="28.000000" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <defs/>
                                    <path id="Vector" d="M12 4C9.62695 4 7.30664 4.7041 5.33301 6.02246C3.35938 7.34082 1.82129 9.21484 0.913086 11.4082C0.00488281 13.6006 -0.232422 16.0137 0.230469 18.3408C0.693359 20.6689 1.83691 22.8066 3.51465 24.4854C5.19336 26.1631 7.33105 27.3066 9.65918 27.7695C11.9863 28.2324 14.3994 27.9951 16.5918 27.0869C18.7852 26.1787 20.6592 24.6406 21.9775 22.667C23.2959 20.6934 24 18.373 24 16C23.9961 12.8184 22.7305 9.76855 20.4814 7.51855C18.2314 5.26953 15.1816 4.00391 12 4ZM12 26C10.0225 26 8.08887 25.4131 6.44434 24.3145C4.7998 23.2158 3.51855 21.6543 2.76074 19.8271C2.00391 18 1.80664 15.9893 2.19238 14.0488C2.57812 12.1094 3.53027 10.3271 4.92871 8.92871C6.32715 7.53027 8.10938 6.57812 10.0488 6.19238C11.9893 5.80664 14 6.00391 15.8271 6.76074C17.6543 7.51855 19.2158 8.7998 20.3145 10.4443C21.4131 12.0889 22 14.0225 22 16C21.9971 18.6514 20.9424 21.1934 19.0674 23.0674C17.1934 24.9424 14.6514 25.9971 12 26ZM17.707 10.293C17.8008 10.3857 17.874 10.4961 17.9248 10.6172C17.9746 10.7383 18.001 10.8682 18.001 11C18.001 11.1318 17.9746 11.2617 17.9248 11.3828C17.874 11.5039 17.8008 11.6143 17.707 11.707L12.707 16.707C12.6143 16.8008 12.5039 16.874 12.3828 16.9248C12.2617 16.9746 12.1318 17.001 12 17.001C11.8682 17.001 11.7383 16.9746 11.6172 16.9248C11.4961 16.874 11.3857 16.8008 11.293 16.707C11.1992 16.6143 11.126 16.5039 11.0752 16.3828C11.0254 16.2617 10.999 16.1318 10.999 16C10.999 15.8682 11.0254 15.7383 11.0752 15.6172C11.126 15.4961 11.1992 15.3857 11.293 15.293L16.293 10.293C16.3857 10.1992 16.4961 10.126 16.6172 10.0752C16.7383 10.0254 16.8682 9.99902 17 9.99902C17.1318 9.99902 17.2617 10.0254 17.3828 10.0752C17.5039 10.126 17.6143 10.1992 17.707 10.293ZM8 1C8 0.734375 8.10547 0.480469 8.29297 0.292969C8.48047 0.105469 8.73438 0 9 0L15 0C15.2656 0 15.5195 0.105469 15.707 0.292969C15.8945 0.480469 16 0.734375 16 1C16 1.26562 15.8945 1.51953 15.707 1.70703C15.5195 1.89453 15.2656 2 15 2L9 2C8.73438 2 8.48047 1.89453 8.29297 1.70703C8.10547 1.51953 8 1.26562 8 1Z" fill="#3fab3e" fill-opacity="1.000000" fill-rule="nonzero"/>
                                </svg>

                                {{ dateFormattedSplit.time }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="selected-station">
                    <div class="block-header">
                        Выбранный филиал
                    </div>
                    <div class="selected-data-card pa-4">
                        <div class="mb-4">
                            <div class="station-description-title">
                                {{ selectedStation.name }}
                            </div>
                            <div class="station-description-text mt-2">
                            </div>
                            <div class="station-description-time">
                                {{ selectedStation.worktime }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step-subheader mt-8">Выбранные услуги</div>
            <div class="selected-data-card" style="height: auto;" v-if="$vuetify.breakpoint.lgAndUp">
                Услуга
            </div>
            <template v-if="$vuetify.breakpoint.lgAndUp">
                <div v-for="repairId in repairIds" :key="repairId" class="selected-data-card" style="height: auto;background: white;">
                    {{getRepairName(repairId)}}
                </div>
            </template>
            <template v-else>
                <div v-for="repairId in repairIds" :key="repairId" class="d-flex">
                    <div class="selected-repair-total">
                        {{getRepairName(repairId)}}
                    </div>
                </div>
            </template>
            <div class="step-action">
                <v-btn
                    elevation="0"
                    :disabled="isLoading"
                    :loading="isLoading"
                    @click="reserve()"
                    class="mb-8"
                >
                    Подтвердить
                </v-btn>
            </div>
        </div>

        <Dialog
            :action-items="reservedDialogActionItems"
            :show.sync="isShownReservedDialog"
            title="Вы успешно записались">
            <!-- <div>Записаться ещё?</div> -->
        </Dialog>

        <Dialog
            :action-items="expressRepairDialogActionItems"
            :show.sync="isShownExpressRepairDialog"
            :title="expressRepairDialogTitle">
            <v-row v-if="selectedExpressRepair">
                <v-col cols="12">
                    <div v-html="selectedExpressRepair.descriptionFormatted"></div>
                </v-col>
            </v-row>
        </Dialog>
        <SelectRepairDialog
            v-model="showSelectRepairDialog"
            :repairTypes="repairTypes"
            :repairs="repairs"
            :selectedRepairs.sync="repairIds"
            :selectedRepairTypeId="selectedRepairTypeId"
            @toggleRepair="toggleRepair"
            @selectRepairTypeId="(type) => { selectedRepairTypeId = type.id }"
            @selectRepairs="(value) => selectedRepairs = value"
        />
        <v-bottom-sheet v-model="showSelectDateTime">
            <div class="date-time-sheet">
                <div v-if="dateTimeSelect==='time'" class="time-select d-flex align-center" style="width:348px; z-index:999;background:white;min-height:200px;height: 100%;">
                    <v-row justify="center" no-gutters style="width:100%; z-index:999;background:white;" v-show="fetchingTime">
                        <v-col style="text-align:center;">
                            <v-progress-circular
                                indeterminate
                                color="red"
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                    <div v-show="!fetchingTime" class="align-self-start justify-space-between" style="height: 100%;">
                        <div class="d-flex flex-column justivy-spase-between" style="height: 100%;justify-content: space-between;">
                            <div>
                                <div class="d-flex align-center justify-center mb-4">
                                    Выберите свободное время
                                </div>
                                <v-row justify="space-between" no-gutters style="width:348px; z-index:999;background:white;">
                                    <v-col
                                        v-for="(timeItem, timeItemIndex) in times"
                                        :key="`time_${timeItemIndex}`"
                                        class="pa-1"
                                        cols="auto">
                                        <v-chip
                                            :color="timeItem.isBusy ? 'grey lighten-2' : (timeItem.isActive ? 'primary' : 'transparent')"
                                            :disabled="timeItem.isBusy"
                                            :input-value="timeItem.isActive"
                                            @click="selectTime(timeItemIndex); isShownDatePicker=false">
                                            {{ timeItem.time }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </div>
                            <div class="d-flex justify-space-between" style="flex-direction: row;">
                                <v-btn
                                    class="block-datetime-btns"
                                    @click="dateTimeSelect='date'"
                                    elevation="0"
                                    style="width:38%"
                                >
                                    <span>Назад</span>
                                </v-btn>
                                <v-btn
                                    class="block-datetime-btns time-select-btn"
                                    @click="showSelectDateTime = false"
                                    elevation="0"
                                    :disabled="!time"
                                    style="width:58%"
                                >
                                    <span>Продолжить</span>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <v-date-picker
                        v-model="date"
                        :first-day-of-week="1"
                        width="348px"
                        no-title
                        next-icon="$chevronRight"
                        prev-icon="$chevronLeft"
                        :header-date-format="monthFormat"
                    />
                    <div class="d-flex justify-space-between">
                        <v-btn
                            class="block-datetime-btns"
                            @click="showSelectDateTime = false"
                            elevation="0"
                            style="width:38%"
                        >
                            <span>Назад</span>
                        </v-btn>
                        <v-btn
                            class="block-datetime-btns time-select-btn"
                            @click="dateTimeSelect = 'time'; fetchFreeTime()"
                            elevation="0"
                            :disabled="!date"
                            style="width:58%"
                        >
                            <span>Выбрать время</span>
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import {
        cloneDeep as _cloneDeep,
        filter as _filter,
        find as _find,
        findIndex as _findIndex,
        forEach as _forEach,
        includes as _includes,
        intersection as _intersection,
        map as _map,
    } from 'lodash'
    import moment from 'moment'
    import { mapGetters, mapMutations, mapState } from 'vuex'
    // import { yandexMap, ymapMarker } from 'vue-yandex-maps'

    import locationService from '@/services/location'
    import ReservationService from '@/services/reservation.service'
    import StationService from '@/services/station.service'

    import Dialog from '@/components/Vuetify/Dialog'

    // import CarItem from '@/components/app/personal/garage/CarItem'
    // import AppStageHeader from '@/components/app/personal/sto/StageHeader'
    import AppStationItem from '@/components/app/personal/station/StationItem'

    import AppCarList from '@/components/app/personal/garage/CarList'
    import CarItemInfo from '@/components/app/personal/garage/CarItemInfo'
    import SelectRepairDialog from './SelectRepairDialog'

    export default {
        name: 'StationOnlineOrder',

        components: {
            Dialog,

            // CarItem,
            // AppStageHeader,
            AppStationItem,

            // yandexMap,
            // ymapMarker,

            AppCarList,
            CarItemInfo,
            SelectRepairDialog,
        },

        data: () => ({
            isLoading: false,

            stageCode: 'car',
            rules: {
                string: value => (!!value && !!(value.trim())) || 'Обязательное поле',
                required: value => !!value || 'Обязательное поле',
            },

            isClientCar: true,
            cityId: undefined,
            carId: undefined,

            isExpressRepairs: true,
            isShownExpressRepairDialog: false,
            expressRepairId: null,
            isShownRepairForm: true,
            tempRepairTypeId: undefined,
            tempRepairId: undefined,
            repairIds: [],
            // Шиномонтаж
            tireFittingRepairIds: [
                '00-00029637', // Шиномонтаж
                '00-00055979', // Диагностика развал / схождение
            ],
            carWashRepairIds: [
                '00-00057507', // Мойка
            ],

            tabs: ['Списком', 'На карте'],
            addressTab: 0,
            stationId: undefined,

            mapCenter: [57.153165835548556, 65.56351504916005],
            mapZoom: 10,

            isShownDatePicker: false,
            times: [],
            date: undefined,
            timeIndex: undefined,

            isShownReservedDialog: false,
            selectedRepairTypeId: null,
            showSelectRepairDialog: false,
            dateTimeSelect: 'date',
            fetchingTime: false,
            showSelectDateTime: false,
            showSelectCityDialog: false,
        }),

        computed: {
            ...mapState('location', {
                locationState: state => state,
            }),

            ...mapGetters({
                cities: 'city/getCities',
                cars: 'car/getCars',
                getCar: 'car/getCar',
                _repairTypes: 'repairType/getRepairTypes',
                getRepairs: 'repair/getRepairs',
                getStations: 'station/getStations',
                getStation: 'station/getStation',
            }),

            repairTypes() {
                const preTypes = [
                    {
                        id: 'all',
                        name: 'Все услуги',
                    },
                    {
                        id: 'my',
                        name: 'Мои услуги',
                    },
                ]
                const repairTypes = [...preTypes, ...this._repairTypes]
                return repairTypes
            },

            appBarData() {
                return {
                    navigationIcon: {
                        type: 'back',
                        click: () => this.handleBack(),
                    },
                    title: 'Онлайн-запись',
                    progress: this.progress,
                }
            },

            stages() {
                return [
                    { code: 'car', title: 'Ваш город и автомобиль', validForm: true },
                    { code: 'repair', title: 'Что ремонтировать?', validForm: true },
                    { code: 'address', title: 'Выберите адрес', validForm: true },
                    // { code: 'date', title: 'Выберите дату', validForm: true },
                    { code: 'end', title: 'Подтвердите запись', validForm: true },
                ]
            },

            progress() {
                return {
                    isEnabled: true,
                    value: 100 / this.stages.length * (this.currentStage.index + 1),
                }
            },

            currentStage() {
                const stage = _find(this.stages, { code: this.stageCode })

                return {
                    title: stage.title,
                    code: stage.code,
                    index: this.getStageIndex(stage.code),
                }
            },

            repairs() {
                let repairs = _cloneDeep(this.getRepairs)
                const stationIds = _map(this.stationsByCity, 'id')

                // Выбрана одна из работ шиномантажа
                const selectedRepairIds = _map(this.selectedRepairs, (item) => item.id)
                const isSelectedTireFittingRepairs = _intersection(this.tireFittingRepairIds, selectedRepairIds)
                const isSelectedCarWashRepairs = _intersection(this.carWashRepairIds, selectedRepairIds)

                _forEach(repairs, (repair) => {
                    let disabled = false

                    if (selectedRepairIds.length) {
                        if (isSelectedTireFittingRepairs.length) {
                            // Если выбрана работа шиномонтажа, то выбор остальных недоступен
                            if (!_includes(selectedRepairIds, repair.id) && !_includes(this.tireFittingRepairIds, repair.id)) {
                                disabled = true
                            }
                        } else {
                            // Если выбрана работа не из шиномонтажа, то работы из шиномонтажа недоступны
                            if (_includes(this.tireFittingRepairIds, repair.id)) {
                                disabled = true
                            }
                        }
                        if (isSelectedCarWashRepairs.length) {
                            // Если выбрана работа мойки, то выбор остальных недоступен
                            if (!_includes(selectedRepairIds, repair.id) && !_includes(this.carWashRepairIds, repair.id)) {
                                disabled = true
                            }
                        } else {
                            // Если выбрана работа не из мойки, то работы из мойки недоступны
                            if (_includes(this.carWashRepairIds, repair.id)) {
                                disabled = true
                            }
                        }
                    }

                    repair.disabled = disabled
                })

                repairs = _filter(repairs, (repair) => {
                    const intersectionStationIds = _intersection(repair.stationIds, stationIds)

                    return !!intersectionStationIds.length
                })
                if (this.selectedRepairTypeId && this.selectedRepairTypeId !== 'all') {
                    if (this.selectedRepairTypeId === 'my') {
                        return _filter(repairs, repair => {
                            return this.repairIds.includes(repair.id)
                        })
                    } else {
                        return _filter(repairs, { type: this.selectedRepairTypeId })
                    }
                } else {
                    return repairs
                }
            },

            expressRepairs() {
                const allRepairs = this.repairs

                const expressRepairs = _filter(allRepairs, { type: ' Техническое обслуживание' })

                const repairs = {}
                _forEach(expressRepairs, repair => {
                    repairs[repair.id] = repair
                })

                return expressRepairs
            },

            stationsByCity() {
                const stations = _cloneDeep(this.getStations)

                return _filter(stations, { city: this.cityId })
            },

            stations() {
                const stations = _cloneDeep(this.getStations)

                const stationIdsList = _map(this.selectedRepairs, 'stationIds')
                const repairStationIds = _intersection(...stationIdsList)

                return _filter(stations, station => {
                    let isRelationRepair = true
                    if (repairStationIds.length) {
                        isRelationRepair = _includes(repairStationIds, station.id)
                    }

                    return station.city === this.cityId && isRelationRepair
                })
            },

            mapPlaceMarks() {
                const mapPlaceMarks = []

                _forEach(this.stations, Station => {
                    mapPlaceMarks.push({
                        id: Station.id,
                        coords: Station.coordinates,
                        properties: {}, // define properties here
                        options: {}, // define options here
                        clusterName: '1',
                        callbacks: {
                            click: function () {
                            },
                        },
                    })
                })

                return mapPlaceMarks
            },

            selectedCar() {
                return this.getCar(this.carId)
            },

            selectedRepairs() {
                const repairs = _cloneDeep(this.getRepairs)

                return _filter(repairs, repair => {
                    return _includes(this.repairIds, repair.id)
                })
            },

            selectedRepairsDeduplicated() {
                const result = {}
                for (const i in this.selectedRepairs) {
                    const repair = this.selectedRepairs[i]
                    if (!result[repair.id]) {
                        result[repair.id] = {
                            id: repair.id,
                            name: repair.name,
                        }
                    }
                }

                return result
            },

            selectedExpressRepair() {
                const repair = this.getRepair(this.expressRepairId)

                if (repair) {
                    const description = repair.description

                    repair.descriptionFormatted = description.split('\n').join('<br>')
                }

                return repair
            },

            selectedStation() {
                return this.getStation(this.stationId)
            },

            dateFormatted() {
                let dateStr = this.date ? moment(this.date).locale('ru').format('dddd, Do MMMM YYYY') : ''
                if (this.timeIndex) {
                    dateStr += ` ${this.times[this.timeIndex].time}`
                }
                return dateStr
            },

            dateFormattedMobile() {
                let dateStr = this.date ? moment(this.date).locale('ru').format('Do MMMM YYYY') : ''
                if (this.timeIndex) {
                    dateStr += `, ${this.times[this.timeIndex].time}`
                }
                return dateStr
            },

            dateFormattedSplit() {
                const dateStr = this.date ? moment(this.date).locale('ru').format('Do MMMM YYYY') : ''
                const timeStr = `${this.times[this.timeIndex].time}`
                return {
                    date: dateStr,
                    time: timeStr,
                }
            },

            time() {
                const timeItem = this.times[this.timeIndex]

                return timeItem?.time
            },

            expressRepairDialogTitle() {
                return this.selectedExpressRepair ? this.selectedExpressRepair.name : 'Услуга'
            },

            expressRepairDialogActionItems() {
                return [
                    {
                        text: 'Отмена',
                        click: () => this.cancelExpressRepairDialog(),
                    },
                    {
                        text: 'Добавить',
                        click: () => this.addExpressRepair(this.expressRepairId),
                    },
                ]
            },

            reservedDialogActionItems() {
                return [
                    // {
                    //     text: 'Записаться',
                    //     click: () => this.newReserve(),
                    // },
                    {
                        text: 'ОК',
                        click: () => this.finishReserve(),
                    },
                ]
            },

            carIdFromRoute() {
                return this.$route.query?.carId || undefined
            },

            cityIdFromRoute() {
                return this.$route.query?.cityId || undefined
            },
        },

        watch: {
            carIdFromRoute: {
                handler() {
                    if (this.carIdFromRoute) {
                        this.carId = this.carIdFromRoute
                    }
                },
                immediate: true,
            },
            cityIdFromRoute: {
                handler() {
                    if (this.cityIdFromRoute) {
                        this.cityId = this.cityIdFromRoute
                    }
                },
                immediate: true,
            },
            stageCode: {
                handler(stageCode) {
                    this.setAppBar(this.appBarData)

                    switch (stageCode) {
                        case 'address':
                            this.$store.dispatch('location/fetch', this.$getLocation)
                            break
                        case 'date':
                            if (!this.date) {
                                this.date = moment()
                                    .utcOffset(5)
                                    .locale('ru')
                                    .toISOString()
                                    .substr(0, 10)
                            }

                            this.fetchFreeTime()
                            break
                    }
                },
                immediate: true,
            },

            repairIds(repairIds) {
                if (repairIds.length) {

                } else {
                    this.showRepairForm()
                }
            },

            date() {
                this.timeIndex = null
                this.fetchFreeTime()
            },

            'repairTypes.length': {
                handler() {
                    if (this.repairTypes.length && !this.selectedRepairTypeId) {
                        this.selectedRepairTypeId = this.repairTypes[0].id
                    }
                },
                immediate: true,
            },
            isShownDatePicker() {
                if (!this.isShownDatePicker) {
                    this.dateTimeSelect = 'date'
                }
            },
        },

        mounted() {
            this.$store.dispatch('car/fetch')
        },

        methods: {
            ...mapMutations({
                setAppBar: 'ui/setAppBar',
            }),

            getRepair(repairId) {
                return _find(this.repairs, { id: repairId })
            },

            getStageIndex(stageCode) {
                return _findIndex(this.stages, { code: stageCode })
            },

            async nextStage() {
                if (this.currentStage.index < this.stages.length - 1) {
                    const formRef = this.currentStage.code + 'Form'
                    let isAllowedNext = true

                    if (this.currentStage.code === 'repair') {
                        if (!this.repairIds.length) {
                            isAllowedNext = false
                        }
                    } else if (this.currentStage.code === 'address') {
                        if (!this.stationId) {
                            isAllowedNext = false
                        }
                    } else if (this.currentStage.code === 'date') {
                        //
                    } else if (this.currentStage.code === 'car') {
                        if (!this.cityId || !this.carId) {
                            isAllowedNext = false
                        }
                    } else if (!this.$refs[formRef].validate()) {
                        isAllowedNext = false
                    }

                    if (isAllowedNext) {
                        this.stageCode = this.stages[this.currentStage.index + 1].code
                        this.$nextTick(() => {
                            this.scrollMeTo(this.stageCode)
                        })
                    }
                }
            },

            prevStage() {
                if (this.currentStage.index > 0) {
                    this.stageCode = this.stages[this.currentStage.index - 1].code
                }
            },

            handleBack() {
                if (this.stageCode === 'car') {
                    this.$router.back()
                } else {
                    this.prevStage()
                }
            },

            createCar() {
                this.$router.push({
                    name: 'GarageCarEdit',
                })
            },

            selectCar(carId) {
                this.$router.push({ query: { carId } })
            },

            nexStageFromCar() {
                if (this.stages[this.getStageIndex('car')].validForm) {
                    this.nextStage()
                }
            },

            toggleRepair(repair) {
                if (_includes(this.repairIds, repair?.id)) {
                    this.removeRepair(repair?.id)
                } else {
                    this.addRepair(repair?.id)
                }
            },

            addExpressRepair(repairId) {
                this.isShownExpressRepairDialog = false
                this.addRepair(repairId)
            },

            cancelExpressRepairDialog() {
                this.isShownExpressRepairDialog = false
            },

            clearRepairForm() {
                this.$refs.repairForm.reset()
            },

            showRepairForm() {
                this.isShownRepairForm = true
            },

            hideRepairForm() {
                this.isShownRepairForm = false
                this.clearRepairForm()
            },

            confirmRepair(repairId) {
                if (this.$refs.repairForm.validate()) {
                    if (repairId) {
                        this.addRepair(repairId)
                        this.clearRepairForm()

                        this.isShownRepairForm = false
                    }
                }
            },

            addRepair(repairId) {
                if (repairId) {
                    this.repairIds.push(repairId)
                }
            },

            removeRepair(repairId) {
                this.repairIds = _filter(this.repairIds, id => id !== repairId)
            },

            mapInit() {
                // console.log('mapInit')
            },

            getDistance(station) {
                if (station) {
                    const coordinates = station.coordinates || []

                    const lat1 = this.locationState.location?.lat || 0
                    const lng1 = this.locationState.location?.lng || 0

                    const lat2 = coordinates[0] || 0
                    const lng2 = coordinates[1] || 0

                    return locationService.getDistanceFormatted(lat1, lng1, lat2, lng2)
                }

                return 0
            },

            selectStation(stationId) {
                this.dateTimeSelect = 'date'
                this.stationId = stationId
                // this.nextStage()
            },

            async fetchFreeTime() {
                this.fetchingTime = true
                const stationId = this.stationId
                const date = moment(this.date).unix()

                const carId = this.carId
                const repairIds = _map(this.selectedRepairs, (item) => item.id)

                if (stationId && date) {
                    try {
                        const result = await StationService.getAvailablePosts({
                            stationId,
                            date,
                            carId,
                            repairIds,
                        })

                        const items = result.response?.items || []

                        const times = []
                        _forEach(items, item => {
                            const time = moment.unix(item.time).utcOffset(5).locale('ru').format('HH:mm')

                            times.push({
                                unix: item.time,
                                time,
                                isBusy: item.available < 1,
                                isActive: false,
                            })
                        })

                        this.times = times
                    } catch (e) {
                        //
                    }
                }
                this.fetchingTime = false
            },

            selectTime(selectedTimeIndex) {
                _forEach(this.times, (timeItem, timeIndex) => {
                    timeItem.isActive = timeIndex === selectedTimeIndex

                    if (timeItem.isActive) {
                        this.timeIndex = timeIndex
                    }
                })
            },

            async reserve() {
                this.isLoading = true

                const timeItem = this.times[this.timeIndex]

                const stationId = this.stationId
                const date = timeItem?.unix
                const comment = ''

                const client = {
                    // Если найден в 1С
                    id: this.$store.state.client.client?.id,
                    // Если не найден в 1С
                    name: this.$store.state.client.client?.fullName,
                    phone: this.$store.state.client.client?.phone,
                }

                const car = {
                    // Если найден в 1С
                    id: this.selectedCar?.id,
                }

                const works = []
                _forEach(this.repairIds, repairId => {
                    works.push({ id: repairId })
                })

                const params = {
                    stationId,
                    date,
                    comment,
                    client,
                    car,
                    works,
                }

                try {
                    await ReservationService.reserve(params)

                    // Показываем диалог об успешной записи
                    this.isShownReservedDialog = true
                } catch (error) {
                    await this.$root.pushNotification({
                        text: error.message,
                        color: 'error',
                    })
                }

                this.isLoading = false
            },

            newReserve() {
                this.isShownReservedDialog = false

                this.stageCode = 'car'

                this.isClientCar = true
                this.cityId = undefined
                this.carId = undefined

                this.isShownRepairForm = true
                this.tempRepairTypeId = undefined
                this.tempRepairId = undefined
                this.repairIds = []

                this.addressTab = 0
                this.stationId = undefined

                this.mapCenter = [57.153165835548556, 65.56351504916005]
                this.mapZoom = 10

                this.isShownDatePicker = false
                this.times = []
                this.date = undefined
                this.timeIndex = undefined
            },

            finishReserve() {
                this.isShownReservedDialog = false

                this.$router.push({ name: 'Station' })
            },

            scrollMeTo(refName) {
                var element = this.$refs[refName]
                var top = element.offsetTop

                window.scrollTo(0, top)
            },

            getRepairName(repairId) {
                const founded = _find(this.repairs, repair => repair.id === repairId)
                return founded?.name || ''
            },
            ending(count) {
                if (count > 4 && count < 21) {
                    return ''
                }
                const lastDigit = count % 10
                if (lastDigit === 1) {
                    return 'а'
                }
                if (lastDigit > 1 && lastDigit < 5) {
                    return 'и'
                }
                return ''
            },
            monthFormat(e) {
                const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
                moment.updateLocale('ru', { months: months })
                return moment(e).format('MMMM, YYYY')
            },

            setCityId(cityId) {
                this.cityId = cityId
                this.$router.push({ query: { cityId } })
                this.showSelectCityDialog = false
            },
        },
    }
</script>

<style scoped>
    /* .express-repair-next-stage-container {
        background: #ffffff;
        z-index: 4;

        position: sticky;
        bottom: 62px;
    } */
    .order-wrapper {
        display: flex;
        flex-direction: column;
        gap: 32px;
    }
    .order-container {
        padding: 50px !important;
        border-radius: 15px !important;
        background: #FFF;
    }
    .mobile .order-container {
        padding: 16px !important;
    }
    .step-header-wrapper {
        display: flex;
        gap: 15px;
        /* margin-bottom: 32px; */
        align-items: center;
    }
    .step-number {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 148.5px;
        border: 1.5px solid #da251c;
        background-color: #fff;
        align-self: start;
        aspect-ratio: 1;
        height: 48px;
        color: #DA251C;
        white-space: nowrap;
        text-align: center;
        padding: 0 17px;
        font: 700 24px/150% Montserrat, sans-serif;
    }
    .mobile .step-number {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: 1.5px solid #da251c;
        background-color: #fff;
        align-self: start;
        aspect-ratio: 1;
        height: 38px;
        color: #DA251C;
        white-space: nowrap;
        text-align: center;
        padding: 0 14px;
        font: 700 17px/150% Montserrat, sans-serif;
    }
    .step-number.passed {
        background-color: #3fab3e;
        color: #fff;
        border: 1.5px solid #fff;
    }
    .step-number.active {
        background-color: #fff;
        border: 1.5px solid #3fab3e;
        color: #3fab3e;
    }
    .step-header {
        color: #36393B;
        font-family: Montserrat;
        font-size: 28px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        /* margin-bottom: 32px; */
    }
    .mobile .step-header {
        font-size: 20px;
    }
    .step-subheader {
        color: #36393B;
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        margin-bottom: 20px;
    }
    .mobile .step-subheader {
        font-size: 16px;
    }
    .step-action {
        margin-top: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .step-action .v-btn {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 2px solid #DA251C;
        background: #DA251C;
        width: 283px;
        height: 52px;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .mobile .step-action .v-btn {
        width: 100%;
    }
    .step-action .v-btn.v-btn--disabled {
        background: #F3F4F4 !important;
        border-color: #F3F4F4 !important;
        color: #36393B !important;
    }
    .selected-car-info {
        margin-left: 64px;
    }
    .mobile .selected-car-info {
        margin-left: 0;
    }
    .block-change {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 1.5px solid #DA251C;
        width: 165px;
        height: 52px;
        background: #fff !important;
        color: #DA251C;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .block-change-mobile {
        margin-top: 20px;
        display: flex;
        width: 100%;
        height: 52px;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 1.5px solid #DA251C;
        background: #fff !important;
        color: #DA251C;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .selected-repairs {
        display: flex;
        gap: 8px;
        margin-top: 28px;
        margin-left: 64px;
    }
    .mobile .selected-repairs {
        margin-left: 0;
        gap: 6px;
        flex-wrap: wrap;
    }
    .selected-repair {
        display: flex;
        padding: 8px 20px;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border-radius: 24px;
        border: 1px solid #F3F4F4;
        background: #F3F4F4;
        color: #36393B;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }
    .mobile .selected-repair {
        padding: 4px 10px 5px 10px;
        white-space: nowrap;
    }
    .mobile .selected-repair span {
        max-width: 85vw;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .repair-types-select {
        display: flex;
        gap: 12px;
    }
    .repair-type {
        display: flex;
        padding: 12px 24px;
        justify-content: center;
        align-items: center;
        gap: 7px;
        border-radius: 36px;
        border: 1.5px solid #DA251C;
        background: #FFF;
        color: #36393B;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
        cursor: pointer;
    }
    .repair-type.active {
        background: #DA251C;
        color: #FFF;
        cursor: default;
    }
    .stations-list {
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-between; */
        gap: 20px;
    }
    .date {
        max-width: 350px;
        font-size: 14px;
    }
    .selected-station-card {
        border: 1.5px solid rgb(243, 244, 244);
        border-radius: 12px;
        background: rgb(243, 244, 244);
    }
    .selected-data-card {
        border: 1.5px solid rgb(243, 244, 244);
        border-radius: 12px;
        background: rgb(243, 244, 244);
        padding: 20px;
        height: 144px;
    }
    .mobile .selected-data-card {
        width: 90vw;
    }
    .selected-data {
        flex-wrap: wrap;
    }
    .selected-data .block-header {
        color: rgb(54, 57, 59);
        font-size: 22px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
    }
    .mobile .selected-data .block-header {
        color: rgb(54, 57, 59);
        font-size: 16px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .selected-data .selected-data-card {
        display: flex;
        align-items: center;
    }
    .selected-repair-total {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 4px 20px 5px 20px;
        box-sizing: border-box;
        border: 1px solid rgb(243, 244, 244);
        border-radius: 24px;
        background: rgb(243, 244, 244);
        margin-bottom: 4px;
    }
    .station-get-route-btn {
        width: 100%;
    }
    .selected-station-description {
        margin: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .selected-station-card .station-description-title {
        color: rgb(54, 57, 59);
        font-size: 20px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .selected-station-card-mobile .station-description-title {
        color: rgb(54, 57, 59);
        font-size: 20px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .visit-date-time {
        display: flex;
        align-items: center;
        margin-top: 6px;
        gap: 10px;
    }
    .mobile .selected-station-card {
        display: flex;
        gap: 16px;
    }

</style>

<style>
    .main {
        /* margin-top: 30px; */
    }
    .main:has(.order-container) {
        background-color: inherit !important;
        border-radius: 0 !important;
        padding: 0 !important;
    }

    .repair-checkbox .v-icon {
        color: #fff;
        border-radius: 4px;
        border: 1.5px solid #8F8F8F;
        width: 24px;
        height: 24px;
    }
    .repair-checkbox.active .v-icon {
        border: 2px solid #DA251C;
    }
    .date .date-picker .v-input fieldset {
        width: 348px;
        height: 44px;

        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 4px 0px;
        box-sizing: border-box;
        border: 1.5px solid rgb(243, 244, 244);
        border-radius: 8px;
        background: rgb(255, 255, 255);
    }
    .date .date-picker .v-input .v-text-field__slot {
        width: 348px;
        height: 44px;
        font-size: 14px;
    }
    .date .date-picker .v-input .v-input__append-inner {
        margin: 0;
        padding: 0;
    }
    .date .date-picker .v-input .v-input__slot {
        padding-right: 0 !important;
    }
    .v-date-picker-table .v-btn.v-date-picker-table__current {
        border-radius: 5px;
        border-color: rgb(218, 37, 28) !important;
        color: rgb(54, 57, 59) !important;
        font-size: 16px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: center;
    }
    .v-date-picker-table .v-btn.v-btn--active {
        border-radius: 5px;
        background-color: rgb(218, 37, 28) !important;
        color: rgb(255, 255, 255) !important;
        font-size: 16px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: center;
    }
    .stations-carousel .v-carousel__controls {
        background: none;
        height: 16px;
        bottom: 10px;
    }
    .stations-carousel .v-carousel__controls .v-btn {
        width: 12px !important;
        height: 12px !important;
        margin: 0 2px;
    }
    .stations-carousel .v-carousel__controls__item .v-icon {
        opacity: 1 !important;
    }
    .stations-carousel .v-carousel__controls .v-icon .v-icon__component {
        font-size: 8px !important;
        height: 8px !important;
        width: 8px !important;
        color: rgb(217, 217, 217) !important;
    }
    .stations-carousel .v-carousel__controls .v-item--active .v-icon .v-icon__component {
        font-size: 12px !important;
        height: 12px !important;
        width: 12px !important;
        color: #3fab3e !important;
    }
    .date-time-sheet {
        box-sizing: border-box;
        border: 1.5px solid rgb(243, 244, 244);
        border-radius: 16px 16px 0px 0px;
        background: rgb(255, 255, 255);
        height: 100%;
        left: 0;
        top: 360px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 30px 16px 30px 16px;
    }
    .date-time-sheet .block-datetime-btns {
        margin-top: 20px;
        display: flex;
        /* width: 100%; */
        height: 52px;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 1.5px solid #DA251C;
        background: #fff !important;
        color: rgb(54, 57, 59) !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .date-time-sheet .block-datetime-btns.v-btn--disabled.time-select-btn {
        border: none;
        color: rgb(54, 57, 59) !important;
        background-color: rgb(243, 244, 244) !important;
    }
    .date-time-sheet .block-datetime-btns.time-select-btn {
        color: white !important;
        background-color: rgb(218, 37, 28) !important;
    }
    .selected-data-card .car-item .params div{
        background: white !important;
    }
    .dialog-card {
        width: 100vw;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }
</style>
